import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { ICardWithValue } from '../../../interfaces/card-with-value.interface';

@Component({
  selector: 'app-card-with-value',
  standalone: true,
  imports: [TranslateModule, NzDividerModule],
  templateUrl: './card-with-value.component.html',
  styleUrls: ['./card-with-value.component.scss'],
})
export class CardWithValueComponent implements OnInit {
  @Input() cardData?: ICardWithValue;
  @Output() actionButtonEmitter: EventEmitter<string> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  actionButton(): void {
    if (this.cardData) {
      this.actionButtonEmitter.emit(this.cardData.id);
    }
  }
}

